class TeachersService {
  constructor() {
    this.apiUrl = process.env.REACT_APP_API_URL;
    this.token = localStorage.getItem('token');
  }

  async analytics(startDate, endDate, page) {
    return fetch(
        `${this.apiUrl}/video-analytics/teachers/progress-analytics/?startDate=${startDate}&endDate=${endDate}&page=${page}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': this.token,
          },
        })
        .then((response) => {
          return response.json();
        });
  }

  async reactions(startDate, endDate, page) {
    return fetch(
        `${this.apiUrl}/video-analytics/teachers/reaction-analytics/?startDate=${startDate}&endDate=${endDate}&page=${page}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': this.token,
          },
        })
        .then((response) => {
          return response.json();
        });
  }

  async teacher(teacherId, startDate, endDate) {
    return fetch(
        `${this.apiUrl}/video-analytics/teachers/${teacherId}?startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': this.token,
          },
        })
        .then((response) => {
          return response.json();
        });
  }
}

export default TeachersService;
